import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DisplayDate } from "../../../../../utils/DisplayDate";
import EcoProButton from "../../../../shared/button/button";
import EcoProOverlayModal from "../../../../shared/modal/OverlayModal/EcoProOverlayModal";
import Feedback from "../../../../../pages/Account/CancelPlan/Feedback/Feedback";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../shared/loader/Loader";
import { currentUserRolesArr, getPlanTranslation, validateRoleAndPathname_CSAGENT_ADMIN } from "../../../../../constants/AppMethod";
import { canAccess_CancelSubscription, userRoles } from "../../../../../constants/UserRoles";
import { Card, CardHeader, ListGroup, ListGroupItem } from "react-bootstrap";
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { SUCCESS } from "../../../../../constants/AppConstants";
import { ReactivateSubscription, ResetSubscriptionReactivationResult } from "../../../../../actions/Dashboard";

const SubscriptionLineItem = ({ label, value, classNameValues = "" }) => {
    return (
        <ListGroupItem>
            <p>{label}:
                <span className={`${classNameValues}`}>{value}</span>
            </p>
        </ListGroupItem>
    )
}

const SubscriptionDetails = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation("CSAgenttranslation");
    const NOT_AVAILABLE = "N/A";
    const ACTIVE = 'ACTIVE';
    const customerSubscriptionInfo = useSelector(state => state.CSAGENT.SubscriptionDetails);
    const DeviceAndDeviceUsageDetails = useSelector((state) => state.CSAGENT.DeviceAndDeviceUsageDetails);
    const reactivatedSubscriptionResult = useSelector(state => state.ReactivateSubscription);
    const TABS = {
        'SUBSCRIPTION_INFO': 'SUBSCRIPTION_INFO'
    }
    const ENROLLMENT_STATUS = {
        'PENDING_ENROLLMENT': 'PendingEnrollment'
    }
    const enrollmentStatus_InActiveClasses = [
        'cancelled',
        'inactive',
        'pendingenrollment',
        'pendingactivation',
        'pendingcancellation',
        'enrollmentcancelled',
        'enrollmentfailed'
    ];

    const [activeTab, setActiveTab] = useState(
        (customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails?.length > 0)
            ? customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails[0].deviceId
            : null);

    const [selectedSubscriptionDetails, setSelectedSubscriptionDetails] = useState(
        (customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails?.length > 0)
            ? customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails[0].deviceId
            : null);

    useEffect(() => {
        if (customerSubscriptionInfo?.subscriptionInfo
            && customerSubscriptionInfo?.subscriptionInfo?.actionStatus?.toUpperCase() === SUCCESS) {
            if (customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails?.length > 0) {
                setActiveTab(customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails[0].deviceId)
                setSelectedSubscriptionDetails(customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails[0]);
            } else {
                setActiveTab(TABS.SUBSCRIPTION_INFO);
            }
        }
    }, [TABS.SUBSCRIPTION_INFO, customerSubscriptionInfo?.subscriptionInfo]);

    // get user details
    const { displayName, emailAddress, countryCode, userId, businessPartnerId: customerBPID } = props?.customerInfo || {};

    const cancelOrderResponse = useSelector((state) => state.CancelOrder);
    const [callCancelOrder, setcallCancelOrder] = useState(true);
    const currentUserRoles = currentUserRolesArr();
    const [modalState, setModalState] = useState(false);
    const [modalProps, setModalProps] = useState({
        modal_title: "",
        modal_sub_title: "",
        modal_content: "",
        cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
        confirm_btn_text: t("MODAL_BUTTON_TXT.CONFIRM"),
        toggleModal: "",
        customClassName: "",
        confirm_btn_onClick: "",
        type: "normal"
    })

    const customerInfo = {
        'deviceId': null,
        'customerCountryCode': countryCode,
        'customerUserId': userId,
        'confirmStatus': true,
        'customerBP_ID': customerBPID
    }

    useEffect(() => {
        if (cancelOrderResponse.loading) {
            setModalState(false);
        }
    }, [cancelOrderResponse.loading]);

    const constructUserInfoContent = (name, emailId, serialNumber, delayedCancellationBillingEndDate = null) => {
        return <>
            <p>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.MODAL_CONTENT")}</p>
            <ul>
                <li><span>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.NAME")}:&nbsp;&nbsp;&nbsp;</span> <span>{name}</span></li>
                <li><span>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.EMAIL")}:&nbsp;&nbsp;&nbsp;</span> <span>{emailId}</span></li>
                <li><span>{t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.SERIAL_NUMBER")}:&nbsp;&nbsp;&nbsp;</span> <span>{serialNumber}</span></li>
            </ul>
            <br />
            <br />
            {
                (delayedCancellationBillingEndDate)
                    ? <p>NOTE: {t("CONFIRM_CANCELLATION.DELAYED_CANCELLATION_TYPE")} {delayedCancellationBillingEndDate}</p>
                    : <p>NOTE: {t("CONFIRM_CANCELLATION.IMMEDEATE_CANCELLATION_TYPE")}</p>
            }
        </>
    }

    const toggleModal = (event) => {
        setModalState(false);
    }

    const confirmedCancellation = () => {
        customerInfo.deviceId = selectedSubscriptionDetails?.deviceId || null;
        setModalState(true);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_FEEDBACK_MODAL_TITLE"),
            modal_content: <Feedback {...{ ...customerInfo, ...{ 'csAgentEcoproCancellation': true } }} />,
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-feedback",
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL")
        });
    }

    const handlePlanCancellationModal = (selectedSubscription) => {
        setModalState(true);
        setSelectedSubscriptionDetails(selectedSubscription);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.MODAL_TITLE"),
            modal_content: constructUserInfoContent(displayName, emailAddress, selectedSubscription?.serialNumber),
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-confirmation",
            confirm_btn_onClick: confirmedCancellation,
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
            confirm_btn_text: t("MODAL_BUTTON_TXT.CONTINUE"),
        });
    }

    const handleDelayedPlanCancellationModal = (selectedSubscription) => {
        // reset reactivate subscription state
        dispatch(ResetSubscriptionReactivationResult());

        setModalState(true);
        setSelectedSubscriptionDetails(selectedSubscription);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_CONFIRMATION_MODAL_CONTENT.MODAL_TITLE"),
            modal_content: constructUserInfoContent(displayName, emailAddress, selectedSubscription?.serialNumber, selectedSubscription?.usageCycleEndDate),
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-confirmation",
            confirm_btn_onClick: confirmedDelayedPlanCancellation,
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL"),
            confirm_btn_text: t("MODAL_BUTTON_TXT.CONTINUE"),
        });
    }

    const confirmedDelayedPlanCancellation = () => {
        customerInfo.deviceId = selectedSubscriptionDetails?.deviceId || null;
        setModalState(true);
        setModalProps({
            modal_title: t("CONFIRM_CANCELLATION.CANCELLATION_FEEDBACK_MODAL_TITLE"),
            modal_content: <Feedback {...{ ...customerInfo, ...{ 'csAgentEcoproCancellation': true }, ...{ 'csAgentEcoProDelayedCancellation': true } }} />,
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-feedback",
            cancel_btn_text: t("MODAL_BUTTON_TXT.CANCEL")
        });
    }

    const handleEnrollmentText = (enrollmentStatus) => {
        let EnrollmentStatus_Txt = null, enrollmentTypeClass = null;
        if (enrollmentStatus === ENROLLMENT_STATUS.PENDING_ENROLLMENT) {
            EnrollmentStatus_Txt = t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_TYPES.PRE_ENROLLMENT_COMPLETED');
            enrollmentTypeClass = "preenrollment";
        } else {
            if (enrollmentStatus?.indexOf("InActive") > -1) {
                EnrollmentStatus_Txt = t(`CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_TYPES.INACTIVE`);
                enrollmentTypeClass = "inactive";
            } else {
                if (enrollmentStatus) {
                    EnrollmentStatus_Txt = t(`CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_TYPES.${enrollmentStatus}`)
                    enrollmentTypeClass = (enrollmentStatus_InActiveClasses.indexOf(enrollmentStatus?.toLowerCase()) > -1) ? "inactive" : "active";
                } else {
                    EnrollmentStatus_Txt = 'N/A';
                    enrollmentTypeClass = 'inactive'
                }
            }
        }
        return { EnrollmentStatus_Txt, enrollmentTypeClass }
    }

    const handleSubscriptionStatus = (subscriptionStatus) => {
        let SubscriptionStatus_Txt = null, subscriptionTypeClass = null;
        if (subscriptionStatus) {
            SubscriptionStatus_Txt = t(`CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_TYPES.${subscriptionStatus}`)
            subscriptionTypeClass = (subscriptionStatus.toUpperCase() === ACTIVE) ? subscriptionStatus?.toLowerCase() : 'preenrollment'
        }
        else {
            SubscriptionStatus_Txt = 'N/A';
            subscriptionTypeClass = 'inactive';
        }
        return { SubscriptionStatus_Txt, subscriptionTypeClass }
    }

    const OnReactivateSubscription = (selectedSubscription) => {
        if (validateRoleAndPathname_CSAGENT_ADMIN(currentUserRoles, window.location.pathname)) {
            const currentUserRole = userRoles.CSAGENT_ADMIN;
            const searchedUserId = userId;
            dispatch(ReactivateSubscription(currentUserRole, searchedUserId, selectedSubscription?.deviceId))
        }
    }

    if ((cancelOrderResponse.success || cancelOrderResponse.error) && callCancelOrder) {
        setModalState(true);
        setModalProps({
            modal_title: (cancelOrderResponse.success)
                ? t('CONFIRM_CANCELLATION.CANCELLATION_COMPLETION_TITLE.SUCCESS')
                : t('CONFIRM_CANCELLATION.CANCELLATION_COMPLETION_TITLE.ERROR'),
            modal_content: <>
                <p>
                    {
                        (cancelOrderResponse.success)
                            ? t("CONFIRM_CANCELLATION.CANCELLATION.SUCCESS")
                            : t("CONFIRM_CANCELLATION.CANCELLATION.ERROR")
                    }
                </p>
                <p>{t('CONFIRM_CANCELLATION.DATA_REFRESHING_CONTENT')}</p>
            </>,
            toggleModal: toggleModal,
            customClassName: "subscription-cancellation-final-status"
        });
        setcallCancelOrder(false);
        setTimeout(() => {
            window.location.reload();
        }, 6000);
    }

    if (customerSubscriptionInfo.loading || reactivatedSubscriptionResult.loading) {
        return <Loader />;
    }

    if (customerSubscriptionInfo.error) {
        return <div className="email-log-error">{t("ERROR_MESSAGES.NO_ACTIVE_SUBSCRIPTION")}</div>;
    }

    if (reactivatedSubscriptionResult.error) {
        return <div className="email-log-error">{t("CS_AGENT_ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR")}</div>;
    }

    if (reactivatedSubscriptionResult.success) {
        window.location.reload();
    }
    return (
        <div className="overview-container subscription-details-wrapper mt-40">
            {cancelOrderResponse.loading && <Loader setOverlay={true}></Loader>}
            <div id="subscription-billing-details">
                <div className="tab-btn-wrapper">
                    <div>
                        <Nav tabs>
                            {(customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails?.length > 0) ?
                                customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails.map((subscription) => (
                                    <NavItem>
                                        <NavLink active={activeTab === subscription.deviceId} onClick={() => {
                                            setActiveTab(subscription.deviceId);
                                            setSelectedSubscriptionDetails(subscription);
                                        }}>
                                            {subscription.serialNumber}
                                        </NavLink>
                                    </NavItem>
                                )) :
                                <NavItem>
                                    <NavLink active={activeTab === TABS.SUBSCRIPTION_INFO} onClick={() => {
                                        setActiveTab(TABS.SUBSCRIPTION_INFO);
                                        setSelectedSubscriptionDetails(null);
                                    }}>
                                        {t('CUSTOMER_DASHBOARD.SUBSCRIPTION_BILLING_DETAILS.TABS.SUBSCRIPTION_INFO')}
                                    </NavLink>
                                </NavItem>
                            }
                        </Nav>
                    </div>
                </div>
                <div className="subscription-info-content-wrapper">
                    <TabContent activeTab={activeTab}>
                        {
                            Array.isArray(customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails) && (customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails?.length > 0) ?
                                customerSubscriptionInfo?.subscriptionInfo?.subscriptionDetails?.map((subscription, index) => (

                                    <TabPane tabId={subscription.deviceId}>
                                        <Card key={index} className="mt-30">
                                            <CardHeader>
                                                {t('CUSTOMER_DASHBOARD.SUBSCRIPTION_BILLING_DETAILS.SERIAL_NUMBER')} :
                                                {subscription?.serialNumber || NOT_AVAILABLE}
                                            </CardHeader>
                                            <ListGroup flush>
                                                <div className="device-details-info mt-15">
                                                    <SubscriptionLineItem
                                                        label={t('CUSTOMER_DASHBOARD.SUBSCRIPTION_BILLING_DETAILS.PLAN_TYPE')}
                                                        value={t(
                                                            'CUSTOMER_DASHBOARD.SUBSCRIPTION_BILLING_DETAILS.CURRENT_PLAN_NAME',
                                                            {
                                                                plan_name: getPlanTranslation(
                                                                    subscription?.subscriptionPlan?.planName || NOT_AVAILABLE,
                                                                    undefined,
                                                                    undefined,
                                                                    (
                                                                        [...(DeviceAndDeviceUsageDetails?.deviceInfo?.activeDevices || []),
                                                                        ...(DeviceAndDeviceUsageDetails?.deviceInfo?.inactiveDevices || [])]
                                                                    ).find(device => device.deviceId === subscription?.deviceId)?.printerType
                                                                ) || NOT_AVAILABLE,

                                                                plan_pages: subscription?.subscriptionPlan?.planPages || NOT_AVAILABLE
                                                            }
                                                        )} />
                                                    <SubscriptionLineItem
                                                        label={t('CUSTOMER_DASHBOARD.SUBSCRIPTION_BILLING_DETAILS.SUBSCRIPTION_NUMBER')}
                                                        value={subscription?.subscriptionNumber || NOT_AVAILABLE}
                                                    />
                                                    {(subscription?.enrollmentDate)
                                                        ? <SubscriptionLineItem
                                                            label={t('CUSTOMER_DASHBOARD.SUBSCRIPTION_BILLING_DETAILS.DATE_STARTED')}
                                                            value={DisplayDate(subscription?.enrollmentDate, { day: '2-digit', month: 'long', year: 'numeric' }) || NOT_AVAILABLE}
                                                        /> : null
                                                    }
                                                    <SubscriptionLineItem
                                                        label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.DEVICE_TYPE')}
                                                        value={subscription?.enrollmentStatus === "EnrollmentSuccessful" ? subscription?.userSubscription ? subscription?.userSubscription?.deviceOption?.toUpperCase() : NOT_AVAILABLE : NOT_AVAILABLE}
                                                        classNameValues={`label-value subscription-type-text active`}
                                                    />
                                                    <SubscriptionLineItem
                                                        label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.ENROLLMENT_STATUS')}
                                                        value={handleEnrollmentText(subscription?.enrollmentStatus)?.EnrollmentStatus_Txt || NOT_AVAILABLE}
                                                        classNameValues={`label-value subscription-type-text ${handleEnrollmentText(subscription?.enrollmentStatus)?.enrollmentTypeClass}`}
                                                    />
                                                    <SubscriptionLineItem
                                                        label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_STATUS')}
                                                        value={handleSubscriptionStatus(subscription?.subscriptionStatus)?.SubscriptionStatus_Txt || NOT_AVAILABLE}
                                                        classNameValues={`label-value subscription-type-text ${handleSubscriptionStatus(subscription?.subscriptionStatus)?.subscriptionTypeClass}`}
                                                    />
                                                    {(subscription?.activatedDate)
                                                        ? <SubscriptionLineItem
                                                            label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_ACTIVATION_DATE')}
                                                            value={DisplayDate(subscription?.activatedDate, { day: '2-digit', month: 'long', year: 'numeric' }) || NOT_AVAILABLE}
                                                        /> : null
                                                    }
                                                    {(subscription?.delayedCancellationRequestDate)
                                                        ? <SubscriptionLineItem
                                                            label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.CANCELLATION_SERVICE_REQUESTED_DATE')}
                                                            value={DisplayDate(subscription?.delayedCancellationRequestDate, { day: '2-digit', month: 'long', year: 'numeric' }) || NOT_AVAILABLE}
                                                        /> : null
                                                    }
                                                    {(subscription?.delayedCancellationDate)
                                                        ? <SubscriptionLineItem
                                                            label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.CANCELLATION_SERVICE_END_DATE')}
                                                            value={DisplayDate(subscription?.delayedCancellationDate, { day: '2-digit', month: 'long', year: 'numeric' }) || NOT_AVAILABLE}
                                                        /> : null
                                                    }
                                                    {(subscription?.cancelledDate)
                                                        ? <SubscriptionLineItem
                                                            label={t('CUSTOMER_DASHBOARD.CUSTOMER_INFO.SUBSCRIPTION_CANCELLED_DATE')}
                                                            value={DisplayDate(subscription?.cancelledDate, { day: '2-digit', month: 'long', year: 'numeric' }) || NOT_AVAILABLE} />
                                                        : null
                                                    }
                                                </div>
                                            </ListGroup>
                                        </Card>
                                        {(canAccess_CancelSubscription(subscription?.enrollmentStatus, currentUserRoles)) ?
                                            <Card key={`cancel-card-${index}`} className="mt-30">
                                                <CardHeader>
                                                    {t('CUSTOMER_DASHBOARD.SUBSCRIPTION_CANCELLATION.header')}
                                                </CardHeader>
                                                <ListGroup flush>
                                                    <ListGroupItem>
                                                        <div>
                                                            <div>
                                                                <h6>Immediate: {t("CONFIRM_CANCELLATION.IMMEDEATE_CANCELLATION_TYPE")}</h6>
                                                            </div>
                                                            <div className="cancellation-btn">
                                                                <EcoProButton id="immediate-cancellation-btn" cname="default" btnID="csagent-subscription-cancellation-btn"
                                                                    onBtnClick={() => handlePlanCancellationModal(subscription)}>
                                                                    {t('MODAL_BUTTON_TXT.CANCEL')}
                                                                </EcoProButton>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        <div>
                                                            <div>
                                                                <h6>End of Month: {t("CONFIRM_CANCELLATION.DELAYED_CANCELLATION_TYPE")} {subscription?.usageCycleEndDate}</h6>
                                                            </div>
                                                            <div className="csagent-delayed-cancellation-btn-wrapper">
                                                                <div className="cancellation-btn">
                                                                    <EcoProButton id="delayed-cancellation-btn" cname="default" btnID="csagent-subscription-cancellation-btn"
                                                                        onBtnClick={() => handleDelayedPlanCancellationModal(subscription)}
                                                                        disabled={!!!subscription?.activatedDate || !!subscription?.delayedCancellationDate}>
                                                                        {t('MODAL_BUTTON_TXT.CANCEL')}
                                                                    </EcoProButton>
                                                                </div>
                                                                {
                                                                    (subscription?.delayedCancellationDate) ?
                                                                        <div className="reactivation-btn">
                                                                            <EcoProButton cname="default csagent-subscription-reactivation-btn" onBtnClick={() => OnReactivateSubscription(subscription)}>
                                                                                {t('CONFIRM_CANCELLATION.REACTIVATE_SUBSCRIPTION')}
                                                                            </EcoProButton>
                                                                        </div>
                                                                        : null
                                                                }
                                                            </div>
                                                        </div>
                                                    </ListGroupItem>
                                                </ListGroup>
                                            </Card> : null
                                        }
                                    </TabPane>
                                )) :
                                <TabPane tabId={TABS.SUBSCRIPTION_INFO}>
                                    <div className="email-log-error">{t("ERROR_MESSAGES.NO_SUBSCRIPTION_INFO_AVAILABLE")}</div>
                                </TabPane>
                        }
                    </TabContent>
                </div>
            </div>
            <EcoProOverlayModal
                {...modalProps}
                modal_state={modalState}
            ></EcoProOverlayModal>
        </div>
    )
}

export default SubscriptionDetails;